import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "poposki" }) {
    ...NewsInfo
  }
}`

export default class NewsText extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Сашко Попоски, македонский тренер по физической подготовке с лицензей A, подписал новый контракт с чемпионом Латвии ФК «Рига» и вошёл в тренерский штаб Олега Георгиевича Кононова. Желаем ему удачи в новом сезоне!</p>
        </div>
      </div>
    )
  }
}